module.exports = __webpack_public_path__ + "img/boss.859dd9cf.png";